<template>
    <v-dialog v-model="value" @input="e => $emit('input', e)" class="pa-0 ma-0 rounded" width="350px">
        <v-card>
          <v-card-title class="d-flex justify-space-between" style="background-color: #DC0B0BE5; position: relative;">
            <span class="px-4" style="color: white; font-weight: bold;">Atención</span>
            <v-btn icon @click="$emit('input', false)">
              <v-icon color="white" class="material-symbols-outlined">close</v-icon>
            </v-btn>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text class="py-6 px-12" style="position: relative;">
            <v-row style="position: relative; padding-top: 50px;"> 
              <v-col cols="12" class="d-flex flex-column" style="position: absolute; top: 0; left: 0; right: 0;">
                <v-icon size="48" color="#DC0B0BE5" class="material-symbols-outlined" style="position: absolute; top: 20px; left: 50%; transform: translateX(-50%);">
                  warning
                </v-icon>
                <span class="text-subtitle-1 font-weight-bold" style="position: absolute; top: 80px; left: 50%; transform: translateX(-50%);">
                  {{ title }}
                </span>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <div style="padding-top: 60px; text-align: center;">
                    <span>{{ description }}</span>
                </div>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    name: 'GenericWarningPopUp',
    data() {
        return {
            vari:true
        }
    },
    props: {
        value:{
            type:[Boolean],
            required:true,
        },
        title: {
            type: [String],
            required: false,
        },
        description: {
            type: [String],
            required: false,
        },
        
    },

    computed: {
    },
    mounted(){
    }
}
</script>

<style scoped>

</style>